import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  USERS_REFRESH: createSagaAction('USERS_REFRESH')
}

// Action Creators
export const actions = {
  usersRefresh: () => ({ type: constants.USERS_REFRESH.ACTION })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.USERS_REFRESH.SUCCESS:
      return { ...state, payload }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/usersActions.js